<template>
  <!-- eslint-disable vue/no-v-html -->
  <v-container
    class="py-0"
    style="background-color: #f4f9ff"
  >
    <v-row
      class="pa-10"
    >
      <div
        class="body-2"
        style="width: 100%;"
      >
        <v-skeleton-loader
          :loading="loading"
          width="700"
          type="sentences@2"
        >
          <div
            id="bioRender"
            class="brandFont fiveHundred ql-editor px-0"
            style="width: 100%; line-height: 1.5rem;"
            v-html="coach.profile.bio"
          ></div>
        </v-skeleton-loader>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Section3',

  props: {
    coach: {
      type: Object,
      default: null,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
  #bioRender {
    &.ql-editor {
      * {
        word-break: break-word !important;
        white-space: normal !important;
        color: black !important;
      }
    }
  }
</style>
